import { CspConfigService } from '@csp/csp-api-client';
import { ZoomConfig, ZoomConfigService } from '@csp/csp-common-zoom';
import { CognitoConfig, CognitoService } from '@csp/csp-fe-auth';
import { DmdpConfigService, PodsConfig } from '@csp/dmdp-api-client';

export interface InitializationConfig {
  getCognitoConfig: () => Promise<CognitoConfig>;
  getDmdpConfig: () => Promise<PodsConfig>;
  getZoomConfig: () => Promise<ZoomConfig>;
}

const init = async ({ getZoomConfig, getDmdpConfig, getCognitoConfig }: InitializationConfig): Promise<void> => {
  const [zoomConfig, dmdpConfig, cognitoConfig] = await Promise.all([
    getZoomConfig(),
    getDmdpConfig(),
    getCognitoConfig(),
  ]);

  await CognitoService.init(cognitoConfig);
  ZoomConfigService.set(zoomConfig);

  DmdpConfigService.setDmdpBaseUrl(dmdpConfig.baseUrl);
  DmdpConfigService.setDmdpPodConfigs(dmdpConfig.pods);

  CspConfigService.setCspPodConfigs({
    csppod: { baseUrl: dmdpConfig.pods.csppod?.baseUrl ?? '' },
    contentdeliverypod: { baseUrl: dmdpConfig.pods.contentdeliverypod?.baseUrl ?? '' },
    'patient-mgmt-api': { baseUrl: dmdpConfig.pods['patient-mgmt-api']?.baseUrl ?? '' },
    'study-api-be': { baseUrl: dmdpConfig.pods['study-api-be']?.baseUrl ?? '' },
    'devices-api-be': { baseUrl: dmdpConfig.pods['devices-api-be']?.baseUrl ?? '' },
  });
};

export const InitializationService = {
  init,
};
